import user from "./user";

export const userReducers = {
  user: user.reducer
};
